<template>
  <div class="login-layout-container bg-light-grey">
    <div class="green-circle left-36 2xl:left-1/4 text-6xl -top-56 h-lg:-top-36">
      <p class="light-text mt-8 2xl:mt-16">
        <span class="bold-text">Virtual</span>
        <br />
        Clinical Experiences
      </p>
    </div>
    <div class="blue-circle bottom-24 2xl:bottom-1/4 right-36 xl:right-64 2xl:right-1/4"></div>

    <!-- <div class="image-wrapper clinicians-team-grid">
      <img
        :class="{ 'fade-in': imagesLoaded.grid }"
        src="/image/login-layout-portraits-grid-min.png"
        alt="clinician-team"
        @load="onImageLoad('grid')"
      />
    </div> -->

    <!-- <div class="image-wrapper clinician-portrait">
      <img
        :class="{ 'fade-in': imagesLoaded.portrait }"
        src="/image/login-layout-portrait-min.png"
        alt="clinician-portrait"
        @load="onImageLoad('portrait')"
      />
    </div> -->
  </div>

  <div
    class="h-screen flex flex-col justify-end 2xl:justify-center"
    style="height: calc(100% - 97px)"
  >
    <slot></slot>
  </div>
  <BrowserCheckModal></BrowserCheckModal>
</template>

<script>
import { ref } from 'vue';
import Intercom from '@intercom/messenger-js-sdk';
import { INTERCOM_APP_ID } from '@/Utils/vice-constants';
import BrowserCheckModal from '@/Components/Modals/BrowserCheckModal.vue';

export default {
  name: 'LoginLayout',
  components: {
    BrowserCheckModal,
  },
  setup() {
    const imagesLoaded = ref({
      grid: false,
      portrait: false,
    });

    const onImageLoad = (imageName) => {
      imagesLoaded.value[imageName] = true;
    };

    return {
      imagesLoaded,
      onImageLoad,
      BrowserCheckModal,
    };
  },

  mounted() {
    Intercom({
      app_id: INTERCOM_APP_ID,
    });
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'EloquiaExtraLight';
  src: url('/fonts/EloquiaExtraLight.ttf') format('truetype');
  font-weight: normal;
}

@font-face {
  font-family: 'EloquiaExtraBold';
  src: url('/fonts/EloquiaExtraBold.ttf') format('truetype');
  font-weight: bold;
}
.login-layout-container {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}

.green-circle {
  height: 603px;
  width: 603px;
  border-radius: 500px;
  color: #ffffff;
  background: #0f766e;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 170px;
}

.blue-circle {
  height: 313px;
  width: 313px;
  border-radius: 500px;
  background: #e0e7ff;
  position: absolute;
}

.light-text {
  font-family: EloquiaExtraLight, serif;
  line-height: 1;
  letter-spacing: 0.7px;
}

.bold-text {
  font-family: 'Inter var', sans-serif;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 2.5px;
}

.image-wrapper {
  position: absolute;

  & img {
    width: 618px;
    height: 618px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease-in-out, visibility 0s 0.2s;
  }

  & img.fade-in {
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
  }

  &.clinician-portrait {
    top: 70px;
    right: -120px;
  }

  &.clinicians-team-grid {
    top: 100px;
    left: -180px;
  }
}
</style>
